import { useEffect, useMemo, useState } from 'react';
import api from '../../../utils/api';
import { profileCardFromMember } from '../utils/clubUtils';

const EMPTY_SEED = {};

function uniqueIds(subjects) {
  if (!Array.isArray(subjects) || subjects.length === 0) return [];
  const seen = new Set();
  const list = [];
  subjects.forEach((item) => {
    const id = item && typeof item === 'object' ? item.id : item;
    if (id == null) return;
    const key = String(id);
    if (seen.has(key)) return;
    seen.add(key);
    list.push(id);
  });
  return list;
}

export function useMemberProfiles(subjects, seedById) {
  const [fetchedById, setFetchedById] = useState({});
  const seed = seedById && typeof seedById === 'object' ? seedById : EMPTY_SEED;
  const ids = useMemo(() => uniqueIds(subjects), [subjects]);

  useEffect(() => {
    const missing = ids.filter((id) => seed[id] === undefined && fetchedById[id] === undefined);
    if (missing.length === 0) return undefined;
    let cancelled = false;
    (async () => {
      const entries = await Promise.all(missing.map(async (id) => {
        try {
          const resp = await api.get(`/users/${id}/profile/`);
          return [id, profileCardFromMember(resp?.data?.data || {})];
        } catch {
          return [id, profileCardFromMember({})];
        }
      }));
      if (cancelled || !entries.length) return;
      setFetchedById((prev) => {
        const next = { ...prev };
        entries.forEach(([id, prof]) => {
          next[id] = prof;
        });
        return next;
      });
    })();
    return () => {
      cancelled = true;
    };
  }, [ids, seed, fetchedById]);

  return useMemo(() => ({ ...fetchedById, ...seed }), [fetchedById, seed]);
}
